export const useModalChildrenHasScroll = (contentRef: HTMLDivElement) => {
  const contentElement = contentRef
  if (!contentElement) return false

  const child = contentElement.children.item(0)
  if (child == null) {
    return false
  }
  const computedStyle = window.getComputedStyle(child)
  const isScrollable =
    (computedStyle.overflowY === "scroll" ||
      computedStyle.overflowY === "auto" ||
      computedStyle.overflow === "scroll" ||
      computedStyle.overflow === "auto") &&
    child.scrollHeight > child.clientHeight

  if (isScrollable) {
    return true
  }

  return false
}
